<label class="w-max">
  <ng-content></ng-content>
  <span *ngIf="required" class="text-error"> *</span>
</label>
